import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';


import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { MaeUsuarioService } from 'src/app/service/mae-usuario.service';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { MaeUsuarioM } from 'src/app/model/mae-usuario-bean';
import { MaeConstanciaM } from 'src/app/model/mae-constancia-bean';

@Component({
  selector: 'app-gestion-constancia-firma',
  templateUrl: './gestion-constancia-firma.component.html',
  styleUrls: ['./gestion-constancia-firma.component.scss']
})

export class GestionConstanciaFirmaComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private maeTablaService:MaeTablaService,
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private maeUsuarioService:MaeUsuarioService,
    private globalVariablesService: GlobalVariablesService,
    private modalService: MDBModalService,
  ){}

  a_tipo:String;
  c_tipo:String;
  tipo_participante:String;

  c_iduser:String;
  c_perfil:String;
  //filtro
  txt_nombre:String;


  listEstado= new Array<Mae_tabla_E>();
  listConstancias:Array<MaeConstanciaM>;
  // para perfil
  listUsuarios = new Array<MaeUsuarioM>();
  c_iduser_firmante:Number;
  x_oficina:String;

  page = 1;
  pageSize = 9;

  ngOnInit(): void {

    this.c_iduser = this.globalVariablesService.getC_usuario();
    this.c_perfil = this.globalVariablesService.getC_perfil();


    this.utilitarioService.loading = true;
    //recuperar parametro
    this.route.params.subscribe((params: Params) => {
      this.a_tipo = params['tipo'];
      //console.log(params);

      if(this.a_tipo==='a')
      {
        this.c_tipo = '19';
        this.tipo_participante = "Alumnos";
      }
      else
      {
        this.c_tipo = '20';
        this.tipo_participante = "Profesores";
      }

      this.txt_nombre = "";
      this.listConstancias= new Array<MaeConstanciaM>();
      this.cargarDatoInicial();

    });
  }
  cargarDatoInicial()
  {
    if(this.c_perfil=='2')
    {
      const cargarEstado = this.maeTablaService.getList("ESTADO_REGISTRO").toPromise()
      .then(result => {
        this.listEstado = result;
      });

      Promise.all([cargarEstado])
        .then(response => {
          this.onBuscar();
          this.utilitarioService.loading = false;
        })
      .catch(error => console.log(`Error in executing ${error}`));
    }

    if((this.c_perfil=='35')&&(this.c_iduser='1'))
    {
      var estado = "3";
      this.maeUsuarioService.getfindFirma(estado).subscribe(data=>{
          this.listUsuarios = data;
          this.c_iduser_firmante =0;
        this.utilitarioService.loading = false;
      });
    }

  }

  onBuscar(){

    this.utilitarioService.loading = true;

    var nombre = "*";
    if(this.txt_nombre.toString().length>0)    nombre = this.txt_nombre.toString();

    this.maeConstanciaService.getfindsign(this.c_tipo.toString(),nombre,this.globalVariablesService.getC_usuario()).subscribe(data=>{
      this.listConstancias = data;
      this.utilitarioService.loading = false;
    });

  }

  onBuscarConstanciasFirmante()
  {
    if(this.c_iduser_firmante!=0)
    {
      localStorage.setItem("c_usuario_firma", this.c_iduser_firmante.toString());
      this.utilitarioService.loading = true;
      var nombre = "*";

      this.maeConstanciaService.getfindsign(this.c_tipo.toString(),nombre,this.c_iduser_firmante.toString()).subscribe(data=>{
        this.listConstancias = data;
        this.utilitarioService.loading = false;
      });
    }
    else
    this.utilitarioService.toastrInfo("Debe seleccionar un firmante para visualizar las constancias.");
  }

  onUsuarioChange()
  {
    var id_user = this.c_iduser_firmante;
    var resul = this.listUsuarios.filter(val => val.c_usuario == id_user);
    if(resul.length>0)
      this.x_oficina = resul[0].x_oficina;
    else
      this.x_oficina = "";
  }

  onVerParticipante(maeConstanciaM:MaeConstanciaM){

    this.router.navigate(['../../gestionparticipantefirma', this.a_tipo,maeConstanciaM.c_constancia],{relativeTo:this.route});
  }
}
